import { render } from "./pause.vue?vue&type=template&id=6b9cce08"
const script = {}

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/icons/pause.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6b9cce08"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6b9cce08', __exports__)) {
    api.reload('6b9cce08', __exports__)
  }
  
  module.hot.accept("./pause.vue?vue&type=template&id=6b9cce08", () => {
    api.rerender('6b9cce08', render)
  })

}


export default __exports__